import React from 'react'
import './couple.css'

const Theme2Nophotocouple = ({ values }) => {
  const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t2-preview-single-couple-container">

        <div className="t2-preview-couple-grandparents">
           {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t2-preview-couple-name">
          {fullname}
        </h1>

        <div className="t2-preview-couple-parents">
            {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      fullname: values.groomFullName || "Groom Full Name",
      parentprefix: values.groomParentsPrefix,
      parentsName: values.groomParents,
      grandParentsPrefix: values.groomGrandParentsPrefix,
      grandParentsName: values.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
       fullname: values.brideFullName || "Bride Full Name",
      parentprefix: values.brideParentsPrefix,
      parentsName: values.brideParents,
      grandParentsPrefix: values.brideGrandParentsPrefix,
      grandParentsName: values.brideGrandParents,
    });

    
  return (
    <div className="t2-couple-section t2-nophoto-couple">
    <img src="/t2-nophotocoupleframe.png" className='t2-preview-couple-frame-border t2-preview-couple-frame-border-top' alt="" />
            <img src="/t2-nophotocoupleframe.png" className='t2-preview-couple-frame-border t2-preview-couple-frame-border-bottom' alt="" />
            <div className="t2-preview-couple-inner">
               <h1 className='t2-preview-couple-heading'> {values.sectionHeading}</h1>
                  <div className="t2-preview-couple-wrapper">
                        {values.displayOrder==="groomFirst"?(
                          <>
                              {groomCard()}
                              <span className="t2-preview-couple-divider">
                        &
                    </span>
                            {brideCard()}
                          </>
                        ): (
                          <>
                              {brideCard()}
                                 <span className="t2-preview-couple-divider">
                        &
                    </span>
                    {groomCard()}
                          </>
                        )}
                       
                  </div>

            </div>
    </div>
  )
}

export default Theme2Nophotocouple